export default "__VITE_ASSET__BSP5j92T__"